import { CHART_THEME_MODE } from '../const';
import { darkChartTheme } from './dark';
import { lightChartTheme } from './light';

export const CHART_THEMES = {
  [CHART_THEME_MODE.LIGHT]: lightChartTheme,
  [CHART_THEME_MODE.DARK]: darkChartTheme,
};
